import React from 'react';
import styles from './Toggle.module.css';

const Toggle = (props) => {
  const { checked, handleChange, className } = props;
  return (
    <div className={className}>
      <label className={styles['toggle-switch']}>
        <span className={styles['toggle-switch-label']}>
          {checked ? 'Hide Details' : 'Show Details'}
        </span>
        <input type="checkbox" checked={checked} onChange={handleChange} />
        <div className={styles['toggle-switch-background']}>
          <div className={styles['toggle-switch-handle']}></div>
        </div>
      </label>
    </div>
  );
};

export default Toggle;
